import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useEffect } from 'react';

export const useMobileOptimizations = () => {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      // Configure status bar
      if (Capacitor.getPlatform() === 'ios') {
        StatusBar.setStyle({ style: Style.Light });
        StatusBar.setOverlaysWebView({ overlay: true });
      } else if (Capacitor.getPlatform() === 'android') {
        StatusBar.hide();
      }
    }
  }, []);

  return {
    isMobile: Capacitor.isNativePlatform(),
    platform: Capacitor.getPlatform(),
  };
};
